import { useQuery } from '@tanstack/react-query';
import userRepository from '@/api/repositories/userRepository/UserRepository.ts';
import { useAuthContext } from '@/context/AuthContext.tsx';

const useUser = () => {
  const { session } = useAuthContext();

  return useQuery({
    queryKey: ['user', session?.user.id],
    queryFn: async () => {
      if (!session?.user.id) return null;
      const { data, error } = await userRepository.findOne({ auth_id: session.user.id });
      if (error) throw error;
      return data;
    },
    enabled: !!session?.user.id,
  });
};

export default useUser; 